import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useCustomer } from "@/context/CustomerContext";
import { api, errMsg } from "@/lib/api";

export default function AuthCallback() {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { completeLogin, refresh } = useCustomer();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(hash.slice(1)).get("session_id");
    api.post("/customer/session", { session_id: sessionId })
      .then(({ data }) => {
        completeLogin(data);
        toast.success(`Halo, ${data.customer.name}!`);
      })
      .catch((e) => {
        toast.error(errMsg(e));
        refresh();
      })
      .finally(() => navigate("/#menu", { replace: true }));
  }, [hash, navigate, completeLogin, refresh]);

  return (
    <div className="min-h-screen bg-cream grid place-items-center" data-testid="auth-callback">
      <Loader2 className="w-8 h-8 animate-spin text-forest" />
    </div>
  );
}
